// extracted by mini-css-extract-plugin
module.exports = {"root":"UpcomingProgram_root__yNTNp","time":"UpcomingProgram_time__UhMla"};